import { GetterTreeWithRootState } from '~/store/types'
import { FlashState } from '~/store/modules/shared/flash/state'

export default {
  flashShown(state, _, __): Boolean {
    return Boolean(state.clientFlashMessage || state.backendFlashMessage)
  }
} as GetterTreeWithRootState<FlashState>
